export default __webpack_public_path__ + "static/media/logo.d925f390.svg";